
import { Lead } from '@/types/lead';
import { supabase } from '@/integrations/supabase/client';
import { mapDbLeadToLead } from '../mappers/leadMapper';

// PERFORMANCE: Optimized query - fetches all relations in a single database call to avoid N+1 queries
export const getLeadsByUserId = async (userId: string): Promise<Lead[]> => {
  try {
    const { data, error } = await supabase
      .from('leads')
      .select(`
        *,
        notes (
          id,
          content,
          created_at,
          created_by,
          lead_id,
          tags,
          updated_at
        ),
        documents (
          id,
          name,
          url,
          type,
          description,
          lead_id,
          created_at,
          uploaded_by
        ),
        lead_images (
          id,
          image_url,
          is_primary,
          position,
          created_at
        ),
        lead_key_contacts (
          id,
          name,
          email,
          phone,
          position,
          is_primary,
          notes,
          created_at,
          created_by
        )
      `)
      .eq('created_by', userId)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching leads by user ID:', error);
      throw error;
    }

    // PERFORMANCE: Map all data in a single pass, no additional queries
    const leads = data.map((lead) => {
      const leadObj = mapDbLeadToLead(lead);
      return {
        ...leadObj,
        images: (lead.lead_images || []).map((img: any) => ({
          id: img.id,
          leadId: lead.id,
          imageUrl: img.image_url,
          isPrimary: img.is_primary,
          position: img.position,
          createdAt: img.created_at
        })),
        keyContacts: (lead.lead_key_contacts || []).map((contact: any) => ({
          id: contact.id,
          leadId: lead.id,
          name: contact.name,
          email: contact.email,
          phone: contact.phone,
          position: contact.position,
          isPrimary: contact.is_primary,
          notes: contact.notes,
          createdAt: contact.created_at,
          createdBy: contact.created_by,
          linkedinUrl: contact.linkedin_url || undefined,
          source: contact.source || 'manual',
          status: contact.status || 'active'
        }))
      };
    });

    return leads;
  } catch (error) {
    console.error('Error in getLeadsByUserId:', error);
    return [];
  }
};
